module.exports = __webpack_public_path__ + "static/sample-01bcd7bc9a8a62ca7012cd9e73609de9.mp4";